import type { BlogPost } from "../services/BlogService";
import { SITE_URL } from "./site";

export function blogPostJsonLd(post: BlogPost, image?: string) {
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: post.title,
    description: post.excerpt,
    datePublished: new Date(post.publishedAt).toISOString(),
    ...(image ? { image } : {}),
    author: { "@type": "Organization", name: "DealHawk", url: SITE_URL },
    publisher: {
      "@type": "Organization",
      name: "DealHawk",
      url: SITE_URL,
      logo: { "@type": "ImageObject", url: `${SITE_URL}/logo-240.png` },
    },
    mainEntityOfPage: `${SITE_URL}/blog/${post.slug}`,
  };
}
